<template>
  <div>
    <div class="scenario_part retire-2 scenario_bgs">
      <div class="container">
        <div class="all_wrapper flex">
          <div class="scenario_dialog" key="2" v-if="optionToggle">
            <h2>等等... 老A啊～ 要吃什麼好呢？</h2>
            <div class="scenario_option">
              <ul>
                <li>
                  <a href="" @click.prevent="toNext('retire_2','retire_3' ,seldomGourmet, '享受美食偶爾吃就好')">
                    <div class="option_img">
                      <img src="@/assets/images/needs/banner-retire/Page-1.svg" alt="">
                    </div>
                    <div class="option_text">
                      <p>享受美食偶爾吃就好</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="" @click.prevent="toNext('retire_2','retire_3', michelin, '米其林餐廳是我家灶咖')">
                    <div class="option_img">
                      <img src="@/assets/images/needs/banner-retire/chef.svg" alt="">
                    </div>
                    <div class="option_text">
                      <p>米其林餐廳是我家灶咖</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="" @click.prevent="toNext('retire_2','retire_3' , localfood, '台灣人就是要吃小吃')">
                    <div class="option_img">
                      <img src="@/assets/images/needs/banner-retire/curry.svg" alt="">
                    </div>
                    <div class="option_text">
                      <p>台灣人就是要吃小吃</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ProgressBar :page="page"></ProgressBar>
    </div>
  </div>
</template>

<script>

import GA from "@/func/seo";
import ProgressBar from '@/components/common/progress_bar'

export default {
  name: "retire_2",
  components: {ProgressBar},
  data: function () {
    return {
      optionToggle: true,
      seldomGourmet: {
        normalCost: 21000,
        nativeCost: 7200,
        abroadCost: 51500
      },
      michelin: {
        normalCost: 33000,
        nativeCost: 7200,
        abroadCost: 82000
      },
      localfood: {
        normalCost: 17175,
        nativeCost: 4900,
        abroadCost: 39600
      },
      page: {
        page_no: 2,
        total: 6,
        isRetire: true
      }
    }
  },
  methods: {
    toNext(from, to, food, option) {
      this.addCost(food)
      let optionNo = 'option2'
      store.dispatch('retire/addOption', {optionNo, option})
      store.set('retire/changeShow!', {from, to})
    },
    addCost(food) {
      store.dispatch('retire/addCostFood', food)
    }
  },
  mounted() {
    GA.pushRetireEvent(2, '要吃什麼好')
  }
}

</script>

<style scoped>
.scenario_dialog .scenario_option ul li {
  margin: 8px;
  background-color: #fff !important;
  border-radius: 6px !important;
  width: 33.3334%;
  border: 3px solid #fff;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  padding: 0 !important;
}

.scenario_dialog .scenario_option ul li:hover {
  border: 3px solid #000 !important;
}

@media (max-width: 767px) {
  .scenario_dialog .scenario_option ul li {
    margin: 8px 0;
    width: 100%;
  }
}
</style>
